<template>
  <div>
    <modal :id="name">
      <template slot="header">Invite User</template>
      <input-control
        v-model="emails"
        labelClass="small font-weight-bold"
        :rows="6"
        control="textarea"
        placeholder="user1@mail.com
user2@mail.com"
      >
        To invite many users, type each email on a separate line
      </input-control>

      <div class="d-flex justify-content-center mt-5">
        <button
          :disabled="inviting || !emails"
          class="btn btn-info"
          @click="sendInvitation()"
        >
          <span
            class="spinner-border spinner-border-sm mr-2"
            v-if="inviting"
            role="status"
            aria-hidden="true"
          ></span>
          <span>Send Invite</span>
        </button>
      </div>
    </modal>
  </div>
</template>
<script>
import Swal from "sweetalert2";
export default {
  name: "InviteUsers",
  props: {
    vendor: {
      type: Object,
    },
    name: {
      type: String,
      default: "invite-users",
    },
  },
  data() {
    return {
      emails: "",
      inviting: false,
    };
  },
  methods: {
    checkEmail: function (email) {
      const emailDotIndex = (email || "").lastIndexOf(".");
      if (emailDotIndex <= (email || "").indexOf("@") + 1) {
        return false;
      }
      return true;
    },
    sendInvitation: function () {
      const users_mails = [];
      const invalid_mails = [];
      const users = this.emails.trim().split("\n");
      users.forEach((email) => {
        if (email.trim() && !users_mails.includes(email.trim())) {
          if (!this.checkEmail(email.trim())) {
            invalid_mails.push(email.trim());
          } else {
            users_mails.push(email.trim());
          }
        }
      });
      if (!users_mails.length) {
        let error = "No users added to invite";
        if (invalid_mails.length) {
          error = `Below emails are invalid:<br>${invalid_mails.join("<br>")}`;
        }
        return Swal.fire({
          title: "Validation Error",
          html: error,
          type: "error",
        });
      }
      this.inviting = true;
      const dataToSend = {
        users: users_mails,
        vendor_name: this.vendor ? this.vendor.name : undefined,
      };
      this.$store.dispatch("users/invite", dataToSend).then((success) => {
        this.inviting = false;
        if (success) {
          this.$store.dispatch("hideModal", this.name);
        }
      });
    },
  },
};
</script>
